'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WoodBurningStoveIcon = function WoodBurningStoveIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M12 113h74V0H12z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement(
                'g',
                {
                    transform: 'translate(15 9)'
                },
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M0 107h100v-2H0zM0 112h100v-2H0z'
                }),
                _react2.default.createElement('path', {
                    fill: '#FFF',
                    d: 'M43.936 12v29.984H25v52.119h4.538l-.903 5.017v5.876h4.094v-5.03l1.139-5.863h32.838l1.618 5.864v5.029h4.45v-5.03l-1.863-5.863h4.575V41.458H56.784V12z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    d: 'M28.975 105H27l.016-5.128L28.058 94l1.942.362-1.025 5.784zM32.975 105H31l.016-5.128L32.058 94l1.942.362-1.025 5.784zM73 105h-1.974v-4.853L70 94.365 71.942 94 73 100.055zM68 105h-1.974v-4.853L65 94.365 66.942 94 68 100.055zM37.067 83.867h26.866V64.559c0-4.647-3.66-8.426-8.162-8.426H45.23c-4.502 0-8.162 3.78-8.162 8.426v19.308zM66 86H35V64.559C35 58.736 39.588 54 45.229 54H55.77C61.412 54 66 58.736 66 64.559V86z'
                }),
                _react2.default.createElement(
                    'mask',
                    {
                        id: 'b',
                        fill: '#fff'
                    },
                    _react2.default.createElement('use', {
                        xlinkHref: '#a'
                    })
                ),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M43 42h2V12h-2zM55 42h2V12h-2zM34 89h32v-2H34z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M77 96H25.032v-2.089h49.903V43.09h-48.87v42.553H24V41h53z'
                }),
                _react2.default.createElement('path', {
                    fill: '#555',
                    mask: 'url(#b)',
                    d: 'M24 90h2v-3h-2zM29 49h2v-3h-2zM34 49h2v-3h-2zM39 49h2v-3h-2zM44 49h2v-3h-2zM49 49h2v-3h-2zM54 49h2v-3h-2zM58 49h2v-3h-2zM64 49h2v-3h-2zM68 49h2v-3h-2z'
                }),
                _react2.default.createElement('path', {
                    d: 'M54.95 78.187c.89.89 2.343.892 3.235 0 .432-.433.67-1.007.67-1.62 0-.61-.238-1.185-.67-1.617L46.051 62.812a2.292 2.292 0 0 0-3.236 0 2.28 2.28 0 0 0-.67 1.62c0 .61.238 1.185.67 1.618l12.134 12.137zM56.566 80a3.424 3.424 0 0 1-2.426-1.004L42.006 66.859A3.407 3.407 0 0 1 41 64.43c0-.917.357-1.779 1.006-2.428a3.436 3.436 0 0 1 4.853 0l12.135 12.138A3.409 3.409 0 0 1 60 76.568c0 .916-.357 1.779-1.006 2.428A3.424 3.424 0 0 1 56.567 80z',
                    stroke: '#555',
                    strokeWidth: '.86',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M54.03 79A3.491 3.491 0 0 1 53 76.515c0-.94.365-1.822 1.03-2.487a3.518 3.518 0 0 1 4.97 0l-.828.828a2.349 2.349 0 0 0-3.315 0 2.331 2.331 0 0 0-.685 1.659c0 .625.243 1.213.685 1.656L54.03 79zM44.491 80c-.893 0-1.787-.34-2.468-1.02A3.48 3.48 0 0 1 41 76.507c0-.932.364-1.808 1.023-2.469L46.061 70l.823.823-4.037 4.04a2.31 2.31 0 0 0-.682 1.645c0 .623.241 1.207.682 1.648.88.879 2.41.879 3.29 0l4.04-4.042.823.823-4.04 4.041A3.478 3.478 0 0 1 44.491 80M55.914 71l-.83-.825 4.054-4.024a2.323 2.323 0 0 0 0-3.3c-.89-.881-2.437-.881-3.326 0l-3.98 3.951-.832-.824 3.98-3.953A3.525 3.525 0 0 1 57.474 61c.943 0 1.829.365 2.494 1.025a3.486 3.486 0 0 1 0 4.951L55.914 71z',
                    stroke: '#555',
                    strokeWidth: '.86',
                    fill: '#555',
                    mask: 'url(#b)'
                }),
                _react2.default.createElement('path', {
                    d: 'M46.972 79l-.828-.829c.913-.913.913-2.4 0-3.312-.887-.887-2.429-.887-3.316 0L42 74.03A3.492 3.492 0 0 1 44.486 73c.939 0 1.822.366 2.486 1.03a3.518 3.518 0 0 1 0 4.97',
                    stroke: '#555',
                    strokeWidth: '.86',
                    fill: '#555',
                    mask: 'url(#b)'
                })
            )
        )
    );
};

WoodBurningStoveIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var WoodBurningStove = function (_React$Component) {
    _inherits(WoodBurningStove, _React$Component);

    function WoodBurningStove() {
        _classCallCheck(this, WoodBurningStove);

        return _possibleConstructorReturn(this, (WoodBurningStove.__proto__ || Object.getPrototypeOf(WoodBurningStove)).apply(this, arguments));
    }

    _createClass(WoodBurningStove, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(WoodBurningStoveIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return WoodBurningStove;
}(_react2.default.Component);

exports.default = WoodBurningStove;